import {gsap} from 'gsap'
import Player from '@vimeo/player'
import {Scroll} from '../utils/scroll'

// console.log('hiding hero')
// document.querySelector('.header .logo-header').style.opacity = 0
// document.querySelector('.header .intro p').style.opacity = 0
//
// document.querySelector('.hero-video').style.opacity = 0
// document.querySelector('.hero-image').style.opacity = 0
//
// document.querySelector('.hero-date').style.opacity = 0
// document.querySelector('.hero-cta').style.opacity = 0
// document.querySelector('.hero-title').style.opacity = 0

// document.querySelector('.hero-main .hero-image img').addEventListener('load', () => {
//     document.querySelector('.hero-main').style.minHeight = 'auto'
// })


export class Hero {
    constructor(el) {
        console.log('Loaded Hero')
        this.el = el
        this.logo = el.querySelector('.logo-header')
        this.presents = el.querySelector('.intro .intro__presents')
        this.credits = el.querySelector('.intro .intro__credits')
        this.soundCta = el.querySelector('.sound_cta')
        this.title = el.querySelector('.hero-title')
        this.main = el.querySelector('.hero-main')
        this.image = el.querySelector('.hero-image')
        this.date = el.querySelector('.hero-date')
        this.videoDesktop = el.querySelector('.hero-video video.desktop-only')
        this.videoMobile = el.querySelector('.hero-video video.mobile-only')
        this.videoWrapper = el.querySelector('.hero-video')

        this.captions = el.querySelector('.hero-captions')

        this.vimeoQrCode = el.querySelector('.hero-qrcode')
        this.vimeoVideo = el.querySelector('.hero-full-video')
        this.vimeoTrailer = el.querySelector('.hero-trailer')
        this._vimeoPlayer = new Player(this.vimeoVideo)
        this._vimeoProgress = 0
        this._vimeoPlayerTrailer = new Player(this.vimeoTrailer)
        this._vimeoProgressTrailer = 0

        this.cta = el.querySelector('.hero-cta')
        this.ctaTrailer = document.querySelector('.hero-trailer-cta a')

        this.hasAnimatedVideo = false
        this.heroImageObserver = null

        this._currentVideoPlaying = null

        this.backgroundSoundPlaying = false

        // this.main.style.minHeight = 'auto'
        this._startIntroAnimation()

        // this.insertVideoSource(this._isMobile())
    }

    _startIntroAnimation () {
        let tl = new gsap.timeline()
        tl.fromTo(this.logo, { y: 100 }, {duration: 1, opacity: 1, y: 0})
        tl.fromTo(this.presents, { y: 100 }, {duration: 1, opacity: 1, y: 0})
        tl.fromTo(this.credits, { y: 100 }, {duration: 1, opacity: 1, y: 0})
        tl.to(this.soundCta, {opacity: 1})
        tl.fromTo(this.image, {opacity: 0}, {duration: 1, opacity: 1}, '<')
        tl.eventCallback('onComplete', () => { this._setupEvents() })
    }

    _canShowVideo() {
        return document.body.classList.contains('access-2')
    }

    _setupEvents() {
        document.body.classList.add('can-animate')
        console.log('hero setup evts')
        let that = this
        let options = {
            threshold: 0.8 // at least x% visible
        }
        this.heroImageObserver = new IntersectionObserver((entries, observer) => {
            console.log('hero intersection')
            that._startHeroImageAnimation(entries, observer)
        }, options)
        this.heroImageObserver.observe(this.main)



        this.cta.addEventListener('click', (e) => {
            e.preventDefault()
            if(this._canShowVideo()) {
                console.log('navigator lan', navigator.language, /^zh\b/.test(navigator.language))
                if (/^zh\b/.test(navigator.language)) { // zh
                    this._showQrCode()
                } else {
                    this._showVimeoVideo()
                }
            } else {
                console.log
                let a = new Scroll()
                a._scrollTo("form")
            }
        })
        this.ctaTrailer.addEventListener('click', (e) => {
            e.preventDefault()
            console.log('navigator lan', navigator.language, /^zh\b/.test(navigator.language))
            if (/^zh\b/.test(navigator.language)) { // zh
                this._showQrCode()
            } else {
                this._showVimeoVideo('trailer')
            }

        })

        this.vimeoQrCode.querySelector('.hero-qrcode__close').addEventListener('click', (e) => {
            e.preventDefault()
            this._hideQrCode()
        })

        this.vimeoVideo.querySelector('.hero-full-video__close').addEventListener('click', (e) => {
            e.preventDefault()
            this._hideVimeoVideo()
        })
        this.vimeoTrailer.querySelector('.hero-trailer__close').addEventListener('click', (e) => {
            e.preventDefault()
            this._hideVimeoVideo()
        })

        this._vimeoPlayer.on('ended', () => { this._hideVimeoVideo() })
        this._vimeoPlayerTrailer.on('ended', () => { this._hideVimeoVideo() })
        this._vimeoPlayer.on('timeupdate', this._onVimeoProgress.bind(this))
        this._vimeoPlayerTrailer.on('timeupdate', this._onVimeoProgress.bind(this))
    }

    _showQrCode() {
        this.vimeoQrCode.style.display = 'block';
        let tl = new gsap.timeline()
        tl.fromTo(this.captions, { opacity: 1}, { opacity: 0})
        tl.fromTo(this.vimeoQrCode, { opacity: 0 }, { opacity: 1}, '<')
    }
    _hideQrCode() {
        let tl = new gsap.timeline()
        tl.fromTo(this.vimeoQrCode, { opacity: 1}, { opacity: 0})
        tl.fromTo(this.captions, { opacity: 0 }, { opacity: 1}, '<')
        tl.eventCallback('onComplete', () => {
            this.vimeoQrCode.style.display = 'none';
        })
    }


    fullMovieIsPlaying = false;
    _showVimeoVideo(type = "main") {

        if (window._soundManager && window._soundManager.playing) {
            this.backgroundSoundPlaying = true
            window._soundManager.stopSound()
        }
        this._currentVideoPlaying = type
        console.log('il tipo?', type)

        let targetVideo, targetPlayer
        if (type === "trailer") {
            targetVideo = this.vimeoTrailer
            targetPlayer = this._vimeoPlayerTrailer

        } else {
            targetVideo = this.vimeoVideo
            targetPlayer = this._vimeoPlayer
            this.fullMovieIsPlaying = true;
            console.log('Movie playing when started?', this.fullMovieIsPlaying);
        }

        targetVideo.style.display = 'block';
        targetPlayer.play()

        let tl = new gsap.timeline()
        tl.fromTo(this.captions, { opacity: 1}, { opacity: 0})
        tl.fromTo(targetVideo, { opacity: 0 }, { opacity: 1}, '<')
        tl.eventCallback('onComplete', () => {
            // this._vimeoPlayer.play()
        })
        if (window.dataLayer) {
            let dataLayer = window.dataLayer
            let video = "video_full"
            console.log('video play type', type)
            if( type === "trailer") {
                video = "video"
            }
            console.log('send datalayer 0%')
            dataLayer.push({
                'event': 'video_play',
                'eventCategory': video,
                'eventAction': '0%',
                'eventLabel': ''
            })
        } else {
            console.warn('No datalayer to send events')
        }
    }

    _hideVimeoVideo() {

        let type = this._currentVideoPlaying

        let targetVideo, targetPlayer
        if (type === "trailer") {
            targetVideo = this.vimeoTrailer
            targetPlayer = this._vimeoPlayerTrailer
            this._vimeoPlayerTrailer.pause()
            console.log('Im closing trailer')

            if (this.fullMovieIsPlaying){
                console.log('Movie playing while closing trailer?', this.fullMovieIsPlaying)
                this._currentVideoPlaying = 'main'
                console.log('whats the type?', this._currentVideoPlaying)
            }
        } else {
            targetVideo = this.vimeoVideo
            targetPlayer = this._vimeoPlayer
            this._vimeoPlayer.pause()

            this.fullMovieIsPlaying = false;
            console.log('Movie playing when closed?', this.fullMovieIsPlaying);
        }
        let tl = new gsap.timeline()
        tl.fromTo(targetVideo, { opacity: 1}, { opacity: 0})
        tl.fromTo(this.captions, { opacity: 0 }, { opacity: 1}, '<')
        tl.eventCallback('onComplete', () => {
            targetVideo.style.display = 'none';
            targetPlayer.setCurrentTime(0)
            this._vimeoProgress = 0
            if (this.backgroundSoundPlaying) window._soundManager.playMain()
        })
    }

    _pushVideoPercentage(perc) {
        let cat = "video_full"
        if (this._currentVideoPlaying === "trailer") {
            cat = "video"
        }
        let event = "video_percentage"
        if (perc === "100%") {
            event = "video_completed"
        }
        if (window.dataLayer) {
            console.log('datalayer pushing', event, cat, perc)
            let dataLayer = window.dataLayer
            dataLayer.push({
                'event': event,
                'eventCategory': cat,
                'eventAction': perc,
                'eventLabel': ''
            })
        }
    }

    _onVimeoProgress(data) {
        if (window.dataLayer) {
            let dataLayer = window.dataLayer
            /*if (data.percent > 0.1 && data.percent < 0.12 && this._vimeoProgress !== 10) {
                this._vimeoProgress = 10
                console.log('send datalayer 10%')
                this._pushVideoPercentage("10%")
            }*/
            if (data.percent > 0.25 && data.percent < 0.26 && this._vimeoProgress !== 25) {
                this._vimeoProgress = 25
                console.log('send datalayer 25%')
                this._pushVideoPercentage("25%")
            }
            if (data.percent > 0.50 && data.percent < 0.51 && this._vimeoProgress !== 50) {
                this._vimeoProgress = 50
                console.log('send datalayer 50%')
                this._pushVideoPercentage("50%")
            }
            if (data.percent > 0.75 && data.percent < 0.76 && this._vimeoProgress !== 75) {
                this._vimeoProgress = 75
                console.log('send datalayer 75%')
                this._pushVideoPercentage("75%")
            }
            if (data.percent > 0.98 && data.percent <= 1 && this._vimeoProgress !== 100) {
                this._vimeoProgress = 100
                console.log('send datalayer 100%')
                this._pushVideoPercentage("100%")
            }
        } else {
            console.warn('No datalayer to send events')
        }
    }


    _startHeroImageAnimation(entries, observer) {
        let that = this
        entries.forEach(entry => {
            // console.log(entry, entry.isIntersecting)
            if (entry.isIntersecting) {
                console.log('animate to video')
                this.heroImageObserver.unobserve(this.main)
                gsap.fromTo(this.title, {opacity: 0, y: 100}, {duration: 1, opacity: 1, y: 0, onComplete: () => {
                        that.showVideo()}
                })
                gsap.fromTo(this.date, {opacity: 0, y: 120}, {duration: 1, opacity: 1, y: 0})
                gsap.fromTo(this.cta, {opacity: 0, y: 140}, {duration: 1, opacity: 1, y: 0})

            }
        })

    }


    _isMobile() {
        return window.matchMedia('(max-width: 1023px)').matches
    }

    insertVideoSource(isMobile) {
        if (isMobile) {
            this.videoMobile.preload = 'auto'
        } else {
            this.videoDesktop.preload = 'auto'
        }
    }

    videoPlay(isMobile) {
        // console.log(this.videoMobile, this.videoDesktop)
        if (isMobile) {
            this.videoMobile.play()
            // this.videoDesktop.stop()
        } else {
            this.videoDesktop.play()
            // this.videoMobile.stop()
        }
    }

    showVideo() {
        console.log('showing video')
        this.insertVideoSource(this._isMobile())
        gsap.to(this.videoWrapper, {duration: 2, opacity: 1})
        this.videoPlay(this._isMobile())
        gsap.to(this.image, {duration: 2, opacity: 0})
    }


    onResize() {

            this.insertVideoSource(this._isMobile())
            this.videoPlay(this._isMobile())

        // this._setupEvents() not needed
    }

}
